













































import VueOptions from '@utils/VueOptions'
import WizardService from '@services/Wizard'
import StepContainer from '@ui/AudienceSetWizard/StepContainer'
import PartnershipSteps from '@ui/AudienceSetWizard/PartnershipStep/PartnershipSteps'
import AudienceAvailabilityList from '@ui/AudienceSetWizard/components/AudienceAvailabilityList'
import RadioGroup from '@ui/AudienceSetWizard/components/RadioGroup'
import CheckboxGroup from '@ui/AudienceSetWizard/components/CheckboxGroup'

settings =
  name: 'PartnershipStorageStep'

  vue:
    props: ['wizard', 'step']
    mixins: [WizardService.step()]

    components: {
      StepContainer,
      PartnershipSteps,
      AudienceAvailabilityList,
      RadioGroup,
      CheckboxGroup,
    }

    data: ->
      storageAvailable: true
      selectedAll: []

    mounted: ->
      @initializeSelectedAllStorages()

    computed:
      audienceAvailabilities: -> @wizard.audienceSetData.audience_availabilities

      optionsForStorageAvailable: ->
        [
          { value: true, label: 'Storage Available' },
          { value: false, label: 'No Storage' },
        ]
      actionsForStorageAvailable: ->
        {
          select: @onSelectStorageAvailable
        }

      storageOptions: ->
        [
          {
            value: 'climate_controlled_storage_available',
            label: 'Climate Controlled',
            iconClass: 'fal fa-air-conditioner',
          },
          {
            value: 'cold_storage_available',
            label: 'Cold',
            iconClass: 'fal fa-wind',
          },
          {
            value: 'frozen_storage_available',
            label: 'Frozen',
            iconClass: 'fal fa-snowflake',
          },
        ]
      storageActions: ->
        select: @syncSelectAllStorages
        unselect: @syncSelectAllStorages

      actionsForSelectAllStorages: ->
        select: @selectAllStorageOption
        unselect: @unselectAllStorageOption

    methods:
      initializeSelectedAllStorages: ->
        @syncSelectAllStorages(option) for option in @storageOptions

      onSelectStorageAvailable: ->
        if @storageAvailable
          @setStorageAvailable()
        else
          @unsetStorageAvailable()
      setStorageAvailable: ->
        for item in @audienceAvailabilities
          item.amenities.storage.push 'storage_available' unless 'storage_available' in item.amenities.storage
      unsetStorageAvailable: ->
        @selectedAll = []
        for item in @audienceAvailabilities
          item.amenities.storage = []

      selectAllStorageOption: (option) ->
        for item in @audienceAvailabilities
          item.amenities.storage.push option.value unless option.value in item.amenities.storage
      unselectAllStorageOption: (option) ->
        for item in @audienceAvailabilities
          item.amenities.storage = item.amenities.storage.filter((s) -> s isnt option.value)

      syncSelectAllStorages: (option) ->
        notAllSelected = @audienceAvailabilities.some((item) -> option.value not in item.amenities.storage)

        if notAllSelected
          @selectedAll = @selectedAll.filter((storage) -> storage isnt option.value)
        else
          @selectedAll.push option.value unless @selectedAll.includes option.value

export default VueOptions.vue settings
